import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useImportMutationBankUIContext } from "../ImportMutationBankUIContext";
import { ImportMutationBankEditForm } from "./ImportMutationBankEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/import-mutation-bank/importMutationBankAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import * as XLSX from "xlsx";
import moment from "moment";
import ImportMutationBankTable from "./ImportMutationBankTable";
import LoadingAnimation from "../loading-animation/LoadingAnimation";

export const ImportMutationBankEditDialog = ({
  history,
  match: { params },
}) => {
  // ImportMutationBank Redux state
  const dispatch = useDispatch();
  const { actionsLoading, importMutationBankForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.importMutationImportMutationBanks.actionsLoading,
      importMutationBankForEdit:
        state.importMutationImportMutationBanks.importMutationBankForEdit,
      error: state.importMutationImportMutationBanks.error,
    }),
    shallowEqual
  );

  const [openDonaturModal, setOpenDonaturModal] = useState(false);

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting ImportMutationBank by id
    dispatch(actions.fetchImportMutationBank(params.id));
  }, [params.id, dispatch]);

  const [currentIndex, setCurrentIndex] = useState();
  const [data, setData] = useState([]);
  useEffect(() => {
    if (importMutationBankForEdit) {
      const data = importMutationBankForEdit.bank_statement.map(
        (item, index) => {
          let obj = { ...item };
          obj.donor_name =
            item.donation_payment &&
            item.donation_payment.donation &&
            item.donation_payment.donation.donor &&
            item.donation_payment.donation.donor.name;
          obj.donor_uuid =
            item.donation_payment &&
            item.donation_payment.donation &&
            item.donation_payment.donation.donor_uuid;
          obj[`program_${index}`] =
            item.donation_payment &&
            item.donation_payment.donation &&
            item.donation_payment.donation.donation_item &&
            item.donation_payment.donation.donation_item[0].program_;
          obj[`fund_type_${index}`] =
            item.donation_payment &&
            item.donation_payment.donation &&
            item.donation_payment.donation.donation_item &&
            item.donation_payment.donation.donation_item[0].type;
          obj["donation_uuid"] =
            item.donation_payment &&
            item.donation_payment.donation &&
            item.donation_payment.donation.donation_item &&
            item.donation_payment.donation.donation_item[0].donation;

          return obj;
        }
      );

      setTimeout(() => {
        setData(data);
      }, 0);
    }
  }, [importMutationBankForEdit]);

  const saveImportMutationBank = (value) => {
    let mutationData = [];
    data.map((item, index) => {
      let mutationObj = {};
      mutationObj.fund_type = value[`fund_type_${index}`] ?? null;
      mutationObj.uuid = item.uuid;
      mutationObj.trx_date = item.trx_date;
      mutationObj.bank_account_uuid = item.bank_account_uuid;
      mutationObj.message = item.message;
      mutationObj.amount = +item.amount;
      mutationObj.donor_uuid = item.donor_uuid;
      mutationObj.program_uuid = value[`program_${index}`] ?? null;
      mutationData.push(mutationObj);
    });
    const finale = {
      bank_import_uuid: params.id,
      mutation: mutationData,
    };

    try {
      finale.mutation.forEach((item, index) => {
        if (item.fund_type) {
          if (!item.program_uuid) {
            throw new Error(`Program Donasi Wajib Diisi Pada Baris ${index + 1}`)
          }
        }
      })
      dispatch(actions.proccessImportMutationBank(finale)).then((response) => {
        toast.success(response?.message, toastOption);
        history.push("/donasi/bank-import");
      });
    } catch (error) {
      toast.error(error?.message, toastOption)
    }

    // console.log('====================================');
    // console.log(finale);
    // console.log('====================================');


  };

  const selectedDonatur = (value) => {
    let arrayCopy = [...data];

    data.forEach((item, index) => {
      if (index === currentIndex) {
        arrayCopy[currentIndex] = {
          ...item,
          donor_uuid: value.uuid,
          donor_name: value.name,
        };
      }
    });
    setData(arrayCopy);
    setOpenDonaturModal(false);
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="Bank">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-light mr-2"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>
              Back
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ImportMutationBankEditForm
            saveImportMutationBank={saveImportMutationBank}
            actionsLoading={actionsLoading}
            data={importMutationBankForEdit}
          />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Mutasi Rekening" />
        <CardBody>
          <ImportMutationBankTable
            dataTable={data}
            selectedDonatur={selectedDonatur}
            setCurrentIndex={setCurrentIndex}
            saveData={saveImportMutationBank}
            openDonaturModal={openDonaturModal}
            setOpenDonaturModal={setOpenDonaturModal}
          />
        </CardBody>
      </Card>
    </>
  );
};
